import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sodium-intake-calculator',
  component: () => import('../../routes/SodiumIntakeCalculator.svelte'),
  card: {
    id: 'sodium-intake-calculator',
    title: 'Sodium Intake Calculator',
    description:
      'Track daily sodium from foods and compare to FDA / AHA guidelines. Includes 50+ common foods, 4 lifestyle presets, and an estimated systolic-BP reduction.',
    icon: 'restaurant',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/sodium-intake-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Sodium Intake Calculator — Daily Sodium Tracker & AHA/FDA Comparison',
    description:
      'Free sodium intake calculator. Track sodium from foods you eat, compare against AHA 1500 mg/day ideal and FDA 2300 mg/day DV, and see the estimated SBP reduction. Includes 50+ common foods and 4 lifestyle presets.',
  },
};

export default meta;